var Instructions = /** @class */ (function () {
    function Instructions(element_selector, info_selector) {
        // create pointer
        var el = jQuery(element_selector);
        var info = jQuery(info_selector);
        var timeout = null;
        el.pointer({
            content: info.html(),
            position: {
                edge: 'left',
                align: 'middle'
            },
            pointerClass: 'ac-wp-pointer wp-pointer wp-pointer-left noclick -nodismiss',
            pointerWidth: 250,
        });
        el.hover(function () {
            el.pointer('open');
            clearTimeout(timeout);
        }, function () {
            timeout = setTimeout(function () {
                el.pointer('close');
            }, 500);
        });
    }
    return Instructions;
}());
export default Instructions;
